import { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/customer/{customerId}/pending-points']['get']['responses']['200']['content']['application/json']

async function requestLoyaltyAccountPendingPoints(customerId: string): Promise<Array<App.LoyaltyAccountPendingPoints>> {
  const response = await requestUtils.get<Response>(`/api/lux-loyalty/customer/${customerId}/pending-points`, {
    credentials: 'include',
  })

  return response.result.pendingPoints.map((pendingPointData): App.LoyaltyAccountPendingPoints => {
    const basePoints = pendingPointData.points
    const bonusPoints = pendingPointData.bonusPoints

    return {
      createdAt: pendingPointData.createdAt,
      id: pendingPointData.id,
      orderId: pendingPointData.orderId,
      orderItemId: pendingPointData.itemId,
      basePoints,
      bonusPoints,
      points: basePoints + bonusPoints,
      statusCredits: pendingPointData.statusCredits + pendingPointData.bonusStatusCredits,
    }
  })
}

export default requestLoyaltyAccountPendingPoints
